export default __webpack_public_path__ + "static/media/data.f190c8a0.svg";